module.exports = __webpack_public_path__ + "media/images/area/area_shimaneM400-849162852f912a89d0f2dc6b5e4ab78c.jpg";